<script>
import SelectField from '@phoenix/mixins/components/form/fields/SelectField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [SelectField],

  setup(props) {
    return useField(props);
  },

  computed: {
    selectFieldClasses() {
      return ['input--select', this.fieldClasses];
    },
  },
};
</script>

<template>
  <div class="input-wrapper input-wrapper-select">
    <select
      :id="fieldUniqueId"
      v-model="value"
      :name="field.name"
      :class="selectFieldClasses"
      :aria-describedby="ariaDescribedby"
      :aria-label="field.ariaLabel"
      :placeholder="field.placeholder"
      :disabled="field.disabled"
      autocomplete="disabled"
      @focus="pushFieldDataTracking"
    >
      <option v-if="emptyChoice" value="" />

      <optgroup v-for="(options, label) in groupedOptions" :key="label" :label="label">
        <option v-for="(option, index) in options" :key="`${label}-${index}`" :value="option.value">
          {{ option.label }}
        </option>
      </optgroup>

      <option v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
